import React, { useState, useEffect } from "react";
import axios from "axios";
import SideNav from "../Dashboard/SideNav";
import Navbar from "../Dashboard/Navbar";
import "../Dashboard/styles.css";

export default function User() {
  const [users, setUsers] = useState([]);

  useEffect(() => {
    // Fetch user data from the backend when the component mounts
    axios
      .get("https://journey-scape-main.vercel.app/api/auth/users") // Change this URL to your backend API endpoint
      .then((response) => {
        setUsers(response.data.users);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  const [admins, setAdmins] = useState([]);

  useEffect(() => {
    // Fetch admin data from the backend when the component mounts
    axios
      .get("https://journey-scape-main.vercel.app/api/auth/admins") // Change this URL to your backend API endpoint for admins
      .then((response) => {
        setAdmins(response.data.admins);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  return (
    <>
      <Navbar />
      <SideNav />
      <div className="db-info-wrap">
        <div className="row">
          <div className="col-lg-12">
            <div className="dashboard-box table-opp-color-box">
              <h4>User List</h4>
              <p>
                Number of users that are registered into JourneyScape Website.
              </p>
              <div className="table-responsive">
                <div className="short-table">
                  <table className="table">
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th>Email</th>
                      </tr>
                    </thead>
                    <tbody>
                      {users.map((user) => (
                        <tr key={user._id}>
                          <td>
                            <span className="list-name">{user.name}</span>
                          </td>
                          <td>{user.email}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div className="dashboard-box table-opp-color-box">
              <h4>Admin List</h4>
              <p>
                Number of admins that are registered in the JourneyScape Website.
              </p>
              <div className="table-responsive">
                <div className="short-table">
                  <table className="table">
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th>Email</th>
                      </tr>
                    </thead>
                    <tbody>
                      {admins.map((admin) => (
                        <tr key={admin._id}>
                          <td>
                            <span className="list-name">{admin.name}</span>
                          </td>
                          <td>{admin.email}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
